export const userProperty = {
    DISABLE_SOUND_FOR_NEW_PATIENT: 'Disable Sound For New Patient',
};

export const booleanUserProperties = [userProperty.DISABLE_SOUND_FOR_NEW_PATIENT];
